/* Homepage hero */
import { gsap } from 'gsap';

export function homepage_hero() {

	( ( $ ) => {
		if ( $( '.block--homepage-hero' ).length <= 0 ) {
			return;
		}

		const init = () => {

			if ( $( window ).width() < 992 ) {
				$( '.block--homepage-hero' )
					.removeClass( 'block--homepage-hero--selected-left' )
					.removeClass( 'block--homepage-hero--selected-right' );
				$( '.block--homepage-hero a' ).off( 'mouseenter mouseleave' );

				return;
			}
		}

		const setup_hovers = () => {
			$( '.block--homepage-hero a' ).on( 'mouseenter', ( ev ) => {
				$( ev.currentTarget ).parentsUntil( '.row' ).each( ( i, e ) => {
					if ( e.className.indexOf( 'left' ) > -1 ) {
						$( '.block--homepage-hero' ).removeClass( 'block--homepage-hero--selected-right' );
						$( '.block--homepage-hero' ).addClass( 'block--homepage-hero--selected-left' );
					} else if ( e.className.indexOf( 'right' ) > -1 ) {
						$( '.block--homepage-hero' ).removeClass( 'block--homepage-hero--selected-left' );
						$( '.block--homepage-hero' ).addClass( 'block--homepage-hero--selected-right' );
					}
				} );
			} );

			$( '.block--homepage-hero' ).on( 'mouseleave', ( ev ) => {
				$( '.block--homepage-hero' )
					.removeClass( 'block--homepage-hero--selected-left' )
					.removeClass( 'block--homepage-hero--selected-right' );	
			} )
		}

		init();
		$( window ).on( 'resize', init );
		$( window ).on( 'resize', setup_hovers );

		const intro_desktop = () => {

			if ( $( window ).width() < 992 ) {
				return;
			}

			const bg_left = '.block--homepage-hero--column-left .background';
			const bg_right = '.block--homepage-hero--column-right .background';
			const img_over = '.block--homepage-hero--row-above';
			const text = '.block--homepage-hero--col-behind a .text-blocks';

			gsap.set( text, {
				opacity: '0'
			} );

			gsap.set( bg_left, {
				left: '100vw'
			} );

			gsap.set( bg_right, {
				right: '100vw'
			} );

			gsap.set( img_over, {
				bottom: '-50%'
			} );

			let timeline = gsap.timeline({
				delay:0.5,
				onStart: () => {
					$( '.block--homepage-hero.invisible' ).removeClass( 'invisible' );
				},
				onComplete: () => {
					$( bg_left ).removeClass( 'intro-animation' ).removeAttr( 'style' );
					$( bg_right ).removeClass( 'intro-animation' ).removeAttr( 'style' );
					$( img_over ).removeClass( 'intro-animation' ).removeAttr( 'style' );
					$( text ).removeClass( 'intro-animation' ).removeAttr( 'style' );

					setup_hovers();
				}
			});

			timeline
				.to( bg_left, {
					duration: 1.5,
					left: 0,
					ease: "circ"
				} )
				.to( bg_right, {
					duration: 1.5,
					right: 0,
					ease: "circ"
				}, "<20%" )
				.to( text, {
					duration: .5,
					opacity: 1,
					ease: "circ"
				}, "<30%" )
				.to( img_over, {
					duration: 1.5,
					bottom: 0,
					ease: "circ"
				}, "<70%" )
				.then( () => {
					$( window ).trigger( 'cove:animation:hero' );
				} );
		}

		const intro_mobile = () => {

			if ( $( window ).width() >= 992 ) {
				return;
			}

			const bg_top = '.block--homepage-hero--column-left .background';
			const bg_bottom = '.block--homepage-hero--column-right .background';
			const img_over = '.block--homepage-hero--row-above';
			const text = '.block--homepage-hero--col-behind a .text-blocks';

			gsap.set( text, {
				opacity: '0'
			} );

			gsap.set( bg_top, {
				top: '100vh'
			} );

			gsap.set( bg_bottom, {
				bottom: '100vh'
			} );

			gsap.set( img_over, {
				left: '-100vw'
			} );

			let timeline = gsap.timeline({
				delay:0.5,
				onStart: () => {
					$( '.block--homepage-hero.invisible' ).removeClass( 'invisible' );
				},
				onComplete: () => {
					$( bg_top ).removeClass( 'intro-animation' ).removeAttr( 'style' );
					$( bg_bottom ).removeClass( 'intro-animation' ).removeAttr( 'style' );
					$( img_over ).removeClass( 'intro-animation' ).removeAttr( 'style' );
					$( text ).removeClass( 'intro-animation' ).removeAttr( 'style' );
				}
			});

			timeline
				.to( bg_top, {
					duration: 1.5,
					top: 0,
					ease: "circ"
				} )
				.to( bg_bottom, {
					duration: 1.5,
					bottom: 0,
					ease: "circ"
				}, "<20%" )
				.to( text, {
					duration: .5,
					opacity: 1,
					ease: "circ"
				}, "<30%" )
				.to( img_over, {
					duration: 1.5,
					left: 0,
					ease: "circ"
				}, "<70%" )
				.then( () => {
					$( window ).trigger( 'cove:animation:hero' );
				} );

		}

		$( document ).ready( () => {
			// $( window ).on( "load", () => {
				// window.requestAnimationFrame( () => {
					intro_desktop();
					intro_mobile();	
				// } );
			// } );	
		} );

	} )( window.jQuery );

}